import { lazy } from "react";

export const oneAppRoutes = [
  {
    Path: "/oneapp/*",
    Component: lazy(() => import("../../container/OneApp/routes.js")),
    meta: {
      name: "Beat Management",
    },
  },
  {
    Path: "/oneapp/kn-reports/*",
    Component: lazy(() =>
      import("../../container/KnReports/KnReportsWrapper.js")
    ),
    meta: {
      name: "Kn Reports",
    },
  },
];
